module.exports = __webpack_public_path__ + "media/images/flags/4x3/bgd-e9ac60d918962f906957700897c87945.svg";